import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import '../../styles/MilestonePopup.css';

export default function MilestonePopup({ milestone }) {
  return (
    <AnimatePresence>
      {milestone ? (
        <motion.div
          className="milestone-popup-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
        >
          <motion.div
            className="milestone-popup-card"
            initial={{ opacity: 0, scale: 0.92, y: 24 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.96, y: 12 }}
            transition={{ duration: 0.28, ease: 'easeOut' }}
            role="dialog"
            aria-modal="true"
            aria-labelledby="milestone-popup-title"
          >
            <div className="milestone-popup-body">
              <h2 id="milestone-popup-title" className="milestone-popup-title">
                {milestone.message}
              </h2>

              <div className="milestone-popup-visual">
                <img
                  src={milestone.cakeImg}
                  alt=""
                  className="milestone-popup-cake"
                />
              </div>
            </div>
            <motion.img
              src={milestone.heroImg}
              alt=""
              className="milestone-popup-character"
              initial={{ x: 80, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: 80, opacity: 0 }}
              transition={{
                duration: 0.4,
                ease: 'easeOut',
                delay: 0.2
              }}
            />
          </motion.div>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
}
